import { createContext } from 'react';

export const MediaContext = createContext({ isMediumLayout: false, isLargeLayout: false });
